import { render, staticRenderFns } from "./CriarEmpresa.vue?vue&type=template&id=0f2063ef&scoped=true"
import script from "./CriarEmpresa.vue?vue&type=script&lang=js"
export * from "./CriarEmpresa.vue?vue&type=script&lang=js"
import style0 from "./CriarEmpresa.vue?vue&type=style&index=0&id=0f2063ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2063ef",
  null
  
)

export default component.exports